module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/186rd7Z/tc-custom/9781460324288.jpg?1713496985506",
      "alt": "This image is the cover for the book From Ruin to Riches"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("From Ruin to Riches\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman on the run finds safety by entering a marriage of convenience with a wealthy nobleman in this suspenseful Regency romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("A lord in want of a wife . . .")]), _c('br'), _c('br'), _vm._v("Ruined and on the run, Julia Prior is in desperate straits when she meets a gentleman with a shocking proposal. Certain he is close to death, William Hadfield, Lord Dereham, sees Julia as the perfect woman to care for his beloved estate when he is gone—if she will first become his wife. "), _c('br'), _c('br'), _vm._v("Marriage is Julia’s salvation—as Lady Hadfield, she can finally escape her sins. Until three years later, when the husband she believes to be dead returns, as handsome and strong as ever and intent on claiming the wedding night they never had!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Louise Allen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Louise Allen has been immersing herself in history for as long as she can remember, finding landscapes and places evoke powerful images of the past. Venice, Burgundy & the Greek islands are favourites. Louise lives on the Norfolk coast & spends her spare time gardening, researching family history or travelling. Please visit Louise's website, www.louiseallenregency.com, her blog https://janeaustenslondon or find her on Twitter @LouiseRegency and on Facebook.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0